import {
    SpringLayout, TreeLayout, DiagramToHyperTreeAdapter, LayeredLayout, LayoutBase, LayoutState
} from "@progress/kendo-diagram-common";

(function() {
    var kendo = window.kendo,
        diagram = kendo.dataviz.diagram;

    kendo.deepExtend(diagram, {
        init: function(element) {
            kendo.init(element, diagram.ui);
        },
        SpringLayout: SpringLayout,
        TreeLayout: TreeLayout,
        GraphAdapter: DiagramToHyperTreeAdapter,
        LayeredLayout: LayeredLayout,
        LayoutBase: LayoutBase,
        LayoutState: LayoutState
    });
})();
